import { AfterViewInit, Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'app-metro-form-input[appArMobileMask]',
  standalone: false

})
export class ArMobileMaskDirective implements AfterViewInit {
  constructor(
    private host: ElementRef<HTMLElement>,
    @Optional() private ngControl?: NgControl
  ) {}

  private get inner(): HTMLInputElement | null {
    // Busca el <input> que está dentro de tu componente
    return this.host.nativeElement.querySelector('input');
  }

  ngAfterViewInit(): void {
    // Si el control ya trae un +549..., mostrarlo “lindo”
    const ctrlVal = this.ngControl?.control?.value as string | null;
    if (ctrlVal && ctrlVal.startsWith('+549')) {
      const nsn = ctrlVal.replace(/^\+549/, '').slice(0, 10);
      const el = this.inner;
      if (el) el.value = this.pretty(nsn);
    }
  }

  // El evento input del <input> interno hace burbujeo: lo capturamos en el host
  @HostListener('input', ['$event'])
  onInput() {
    const el = this.inner;
    if (!el) return;

    const e164 = this.toE164(el.value);
    const nsn = e164.replace(/^\+549/, '');
    el.value = this.pretty(nsn); // lo que ve el usuario

    // y en el FormControl guardamos el E.164 limpio
    this.ngControl?.control?.setValue(e164, { emitEvent: true, emitModelToViewChange: false });
  }

  /** Convierte lo que tipeó el usuario a +549XXXXXXXXXX */
  private toE164(raw: string): string {
    let d = (raw || '').replace(/\D+/g, '');

    // quitar 00 y formatos locales 0/15
    if (d.startsWith('00')) d = d.slice(2);
    d = d.replace(/^0+/, '').replace(/^15/, '');

    // normalizar a 549 + NSN(10)
    if (d.startsWith('54') && !d.startsWith('549')) d = '549' + d.slice(2);
    if (!d.startsWith('54')) d = '549' + d;

    const nsn = d.replace(/^549/, '').slice(0, 10);
    return nsn ? `+549${nsn}` : '';
  }

  /** Formato visible: +54 9 11 1234-5678 (CABA) o +54 9 351 123-4567 (heurística) */
  private pretty(nsn: string): string {
    if (!nsn) return '+54 9 ';
    if (nsn.startsWith('11')) {
      const a = nsn.slice(0, 2), b = nsn.slice(2, 6), c = nsn.slice(6, 10);
      return `+54 9 ${a} ${b}${c ? '-' + c : ''}`.trim();
    } else {
      const a = nsn.slice(0, 3), b = nsn.slice(3, 6), c = nsn.slice(6, 10);
      return `+54 9 ${a} ${b}${c ? '-' + c : ''}`.trim();
    }
  }
}